import fetch from '../../utils/fetch'

export function getUserCouponList(params) {
    return fetch({
        url: '/webApi/encrypt/userCoupon/userCouponList',
        method: 'POST',
        isEncrypt:true,
        merId :"10002211252",
        data:params
    })
}

export function userGiveCoupon(params) {
    return fetch({
        url: '/webApi/encrypt/userCouponGive/userGiveCoupon',
        isEncrypt:true,
        merId :"10002211252",
        method: 'POST',
        data:params
    })
}

export function getAvailableCouponList(params) {
    return fetch({
        url: '/api/userCoupon/userAvailableCouponList',
        method: 'GET',
        params
    })
}

export function userUseCoupon(params) {
    return fetch({
        url: '/api/userCoupon/userUseCoupon',
        method: 'POST',
        data:params
    })
}

export function userAvailableCouponListByUserId(params) {
    return fetch({
        url: '/api/userCoupon/userAvailableCouponListByUserId',
        method: 'GET',
        params
    })
}
